export const ACTIVITY_TYPE = {
  COURSE_STARTED: 'course_started',
  LEVEL_STARTED: 'level_started',
  LEVEL_COMPLETED: 'level_completed',
  PERFECT_LEVEL: 'perfect_level',
  TEST_STARTED: 'test_started',
  TEST_COMPLETED: 'test_completed',
} as const;

export type ActivityType = (typeof ACTIVITY_TYPE)[keyof typeof ACTIVITY_TYPE];
